import { render, staticRenderFns } from "./SkuMgmt.vue?vue&type=template&id=748ac08a"
import script from "./SkuMgmt.vue?vue&type=script&lang=js"
export * from "./SkuMgmt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports